<template>
	<div class="study">
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="help_details_cont bg_gray">
			<div class="w1200 bg_white radius8">
				<div class="tc f20px" style="padding-top: 30px;">{{details.name}}</div>
				<div class="help_item_cont" v-html="details.content"></div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'special_details',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: 4,
				myInfo: {},
				public: {},
				id: "",
				details: {},
			}
		},
		mounted() {
			this.getDetails();
		},
		created() {
			this.id = this.$route.query.id;
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getDetails () {
				this.$get("/api/article/get_article_sel",{
					id: this.id,
				})
				.then(res => {
					this.details = res.data;
				});
			},
			searchBtn () {
				
			},
		},
	}
</script>

<style>
</style>
